<template>
  <div>
    <select class="form-control" :id="id" :name="name" :disabled="disabled" :required="required" style="width:100%" ></select>
  </div>
</template>

<script>
import $ from 'jquery';
import 'select2/dist/js/select2.full';
import 'select2/dist/css/select2.min.css'

export default {
  name: 'Select2',
  data() {
    return {
      select2: null
    };
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {}
    },
    value: null
  },
  watch: {
    options(val) {
      this.setOption(val);
    },
    value(val) {
      this.setValue(val);
    }
  },
  methods: {
    /* --- 1) NORMALISASI DATA --- */
    normalizeOptions(list = []) {
      // handle array biasa & optgroup (children)
      return (list || [])
        .filter(Boolean)
        .map(o => {
          if (o.children && Array.isArray(o.children)) {
            const children = this.normalizeOptions(o.children);
            const text = (o.text == null ? '' : String(o.text));
            return text
              ? { ...o, text, children }
              : { ...o, children }; // optgroup boleh tanpa text
          }
          const id   = o.id != null ? o.id : (o.value != null ? o.value : null);
          const text = (o.text == null ? '' : String(o.text));
          return (id != null && text !== '')
            ? { ...o, id, text }
            : null;
        })
        .filter(Boolean);
    },

    /* --- 2) MATCHER AMAN (override bawaan Select2) --- */
    safeMatcher(params, data) {
      const term = (params && params.term != null) ? String(params.term) : '';
      const text = (data && data.text != null)     ? String(data.text)   : '';

      // jika tidak ada filter → tampilkan data apa adanya
      if (term === '') return data;

      // cocokkan diri sendiri
      if (text.toLowerCase().indexOf(term.toLowerCase()) > -1) return data;

      // kalau punya anak (optgroup), filter anak-anaknya
      if (data.children && data.children.length) {
        const matchedChildren = data.children
          .map(child => this.safeMatcher(params, child))
          .filter(c => c != null);
        if (matchedChildren.length) {
          // kembalikan node dengan children yang sudah terfilter
          return { ...data, children: matchedChildren };
        }
      }
      return null;
    },

    setOption(val = []) {
      const safe = this.normalizeOptions(val);
      this.select2.empty();
      this.select2.select2({
        placeholder: this.placeholder,
        width: '100%',
        dropdownParent: this._dropdownParent,  // diset di mounted
        matcher: this.safeMatcher,             // <-- pakai matcher aman
        ...this.settings,
        data: safe
      });
      this.setValue(this.value);
    },

    setValue(val) {
      const v = Array.isArray(val) ? val : (val == null ? [] : [val]);
      this.select2.val([...v]).trigger('change');
    }
  },
  mounted() {
    // console.log(this.placeholder);
    // let firstoption = [{id:'',text:'Pilih Pilihan'}];
    // console.log(firstoption.concat(this.options));
    const $root = $(this.$el);
    const $parent =
      $root.closest('.modal-body').length ? $root.closest('.modal-body') :
      $root.closest('.modal-content').length ? $root.closest('.modal-content') :
      $root.closest('.modal').length ? $root.closest('.modal') :
      $(document.body); // fallback

    // Pastikan parent punya positioning agar absolute child terukur relatif
    if ($parent.is('.modal-body')) {
      $parent.css('position', 'relative'); // aman; tidak merusak layout
    }
    this.select2 = $(this.$el)
      .find('select')
      .select2({
        placeholder: this.placeholder,
        width: '100%',                          // ⬅️ pastikan full width
        dropdownParent: $parent, // <<< kunci posisi
        matcher: this.safeMatcher, 
        ...this.settings,
        data: this.options
        // data: firstoption.concat(this.options)
      })
      .on('select2:open', () => {
        // tunggu dropdown ter-render, lalu fokus
        setTimeout(() => {
          const input = document.querySelector(
            '.select2-container--open .select2-search__field'
          );
          if (input) {
            input.focus();
            input.select(); // opsional: select semua teks jika ada
          }
        }, 0);
      })
      .on('select2:select select2:unselect', ev => {
        this.$emit('change', this.select2.val());
        this.$emit('select', ev['params']['data']);
      })
      .on('select2:closing', ev => {
        this.$emit('closing', ev);
      })
      .on('select2:close', ev => {
        this.$emit('close', ev);
      })
      .on('select2:opening', ev => {
        this.$emit('opening', ev);
      })
      .on('select2:open', ev => {
        this.$emit('open', ev);
      })
      .on('select2:clearing', ev => {
        this.$emit('clearing', ev);
      })
      .on('select2:clear', ev => {
        this.$emit('clear', ev);
      });
    this.setValue(this.value);
  },
  beforeDestroy() {
    this.select2.select2('destroy');
  }
};
</script>
